export const API_URL = process.env.REACT_APP_API_URL;
export const WHALE_URL = process.env.REACT_APP_WHALE_URL;
export const KEY_STORE_USER = "nftstudios_backoffice_user";

export const KEY_STORE_I18N = "nftstudios_backoffice_i18n";
export const KEY_PROJECT = "NFTSTUDIOS|BS";
